/*
 * 路由路径配置文件
 */
import menu from './routes-menu.js'
var rest = [{
  path: '/',
  component: () => import('@/views/Init'),
  redirect: '/default',
  meta: {
    title: '入口页面',
    icon: null,
    requireAuth: false, //表示进入这个路由是否需要登录验证
  },
  children: [{
      path: '/default',
      name: "default",
      component: () => import('@/views/open/Default'),
      meta: {
        title: '入口默认页',
        icon: null,
        requireAuth: false, //表示进入这个路由是否需要登录验证
      }
    },
    {
      path: '/login',
      name: "login",
      component: () => import('@/views/open/login/Login'),
      props:route=>({m:route.query.m}),
      meta: {
        title: '供应商登录',
        icon: null,
        requireAuth: false, //表示进入这个路由是否需要登录验证
      }
    },
    {
      path: '/r-pass',
      name: "r-pass",
      component: () => import('@/views/open/retrieve'),
      meta: {
        title: '找回密码',
        icon: null,
        requireAuth: false, //表示进入这个路由是否需要登录验证
      }
    },
    {
      path: '/sign-in',
      name: "sign-in",
      component: () => import('@/views/open/signin'),
      meta: {
        title: '注册',
        icon: null,
        requireAuth: false, //表示进入这个路由是否需要登录验证
      }
    },
    {
      path: '/login-mail',
      name: "login-mail",
      component: () => import('@/views/open/login/LoginEmail'),
      props:route=>({k:route.query.k}),
      meta: {
        title: '电子邮箱认证',
        icon: null,
        requireAuth: false, //表示进入这个路由是否需要登录验证
      }
    },
    {
      path: '/ca',
      name: "ca",
      component: () => import('@/views/open/e_cert'),
      meta: {
        title: '电子证书下载',
        icon: null,
        requireAuth: false, //表示进入这个路由是否需要登录验证
      }
    }
  ]
}];
//拼接菜单
menu.forEach((item, index) => {
  rest.push(item);
});
export default rest;



// WEBPACK FOOTER //
// ./src/router/routes.js